import { FormattedMessage } from "react-intl";
import {
  CountryFragment,
  CurrentTenantFragment,
  TenantFragment,
  TenantOptionFragment,
} from "../graphql";
import { formatDateTime } from "./dates";
import { formatNationalIDLabel } from "./common";

export function formatTenantName(
  tenant: TenantFragment | CurrentTenantFragment | TenantOptionFragment
) {
  return tenant.fullName || tenant.name;
}

export function formatTestDataResetAt(tenant: CurrentTenantFragment) {
  return tenant.resetAt ? (
    <FormattedMessage
      id="tenants.testMode.resetAt"
      defaultMessage="Reset at {date}"
      values={{ date: formatDateTime(tenant.resetAt) }}
    />
  ) : (
    <FormattedMessage
      id="tenants.testMode.createdAt"
      defaultMessage="Created at {date}"
      values={{ date: formatDateTime(tenant.createdAt) }}
    />
  );
}

export function formatSSNLabel(country?: CountryFragment) {
  return country?.ssnName || "SSN";
}

export function formatTaxIDLabel(country?: CountryFragment) {
  return (
    country?.taxId || <FormattedMessage id="taxId" defaultMessage="Tax ID" />
  );
}

export function formatTenantNationalIDLabel(
  tenant: CurrentTenantFragment | TenantFragment
) {
  return formatNationalIDLabel(tenant.address?.country);
}
